import React from 'react'
import './Advantage_of_Loan.css'
import Advantage_Card from './Advantage_Card/Advantage_Card'
import RedRoundBtn from '../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn'

const Advantage_of_Loan = () => {
    const scrollToSection = (id, offset = 100) => {

        const section = document.getElementById(id);
        if (section) {
            const top = section.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: "smooth" });
        }
    };

    return (
        <section className='Advantage_of_Loan'>
            <div className='conatiner_fluid p-0'>
                <div className='bg_img_holder'>
                    {/* <img src="\assets\Image\Home\Advantage\bg_img.png" className='bg_img' /> */}


                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <div className='main_info_div'>
                                    <p className='title'>
                                        Advantages of getting <br /> Loan or Insurance from  <br /> Profcyma
                                    </p>

                                    <p className='subtext'>
                                        We simplify your financial journey by offering personalized loan and insurance solutions tailored to your specific needs. Benefit from competitive rates & flexible terms, maximizing your financial advantages.
                                    </p>

                                    <p className='footer_text1'>
                                        Live Your Best Life Today,
                                    </p>

                                    <p className='fotter_text2'>
                                        Your Tomorrow Is Secured <span className='inner_text'>With Us!</span>
                                    </p>

                                    <div className="btn_holder" style={{ width: "fit-content" }}>
                                        <RedRoundBtn btn_name="Know More" onClick={() => scrollToSection("key_feature")} />
                                    </div>

                                </div>
                            </div>

                            <div className='col-lg-6 col-md-12 col-sm-12 col-sm-12'>

                                <div className='rigth_side_div'>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-6 col-sm-6 custom_col'>
                                            <div className='card_col_1'>
                                                <div className='card_conatiner_1'>
                                                    <Advantage_Card number="01" title="Streamlined Processes" descn="We simplify coordination between customers and financial institutions." />
                                                </div>

                                                <div className='card_conatiner_2'>
                                                    <Advantage_Card number="03" title="Personalized Guidance" descn="Our advisors help you understand available options." />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-lg-6 col-md-6 col-sm-6 custom_col'>
                                            <div className='card_col_2'>
                                                <div className='card_conatiner_3'>
                                                    <Advantage_Card number="02" title="Competitive Options" descn="Compare multiple offerings shared by partner lenders." />

                                                </div>

                                                <div className='card_conatiner_4'>
                                                    <Advantage_Card number="04" title="Cutting-edge technology " descn="Advanced technology for effortless loan and insurance management." />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='center_container'>
                                        <div className='img_holder'>
                                            <img src='/assets/Image/Home/Advantage/rupee.png' className='ruppe_img' />
                                        </div>
                                    </div>


                                </div>



                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </section>
    )
}

export default Advantage_of_Loan
